import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Result } from '../models/result';
import { getStaffBySchool, getTotalNumberOfActiveStaff } from '../repositories/user/staffRepo';


const useStaffStore = create(persist(
    (set, get)=>({
        staff: [],
        isStaffLoading: false,
        totalNumberOfActiveStaff: 0,
        isTotalNumberOfActiveStaffLoading: false,
        totalNumberOfActiveStaffError: null,
        staffError: null,
        getStaffBySchool: async (schoolId) => {
            set({ isStaffLoading: true });
            const result = await getStaffBySchool(schoolId);
            if(result.success){
                set({ staff: result.value, isStaffLoading: false });
                
            }else{
                set({ staffError: result.message, isStaffLoading: false });
            }
            return result;
        },
        getTotalNumberOfActiveStaff: async (schoolId) => {
            set({ isTotalNumberOfActiveStaffLoading: true });
            const result = await getTotalNumberOfActiveStaff(schoolId);
            if(result.success){
                set({ totalNumberOfActiveStaff: result.value, isTotalNumberOfActiveStaffLoading: false });
            }else{
                set({ totalNumberOfActiveStaffError: result.message, isTotalNumberOfActiveStaffLoading: false });
            }
        },
    }),
    {
        name: 'staff-storage',
        partialize: (state) => ({
            staff: [],
        }),
    }
))

export default useStaffStore;
